import { useAuthStore } from "../../stores/authStore";

export default async (to, from, next) => {
    const auth = useAuthStore();
    await auth.authUser();

    !auth.isGuest && auth.user ? next({ name: "portal.homepage" }) : next();
};
